/**
 * Central konfiguration för segmentrelaterade texter i offertflödet.
 * Redigera här i stället för i enskilda komponenter.
 */

export const SEGMENT_TITLES = [
  'Kontorsåtervinning',
  'Bostadsfastighet',
  'Detaljhandel',
  'Hotell & restaurang',
  'Annat',
] as const;

export type SegmentTitle = (typeof SEGMENT_TITLES)[number];

/** Steg 2 – val av segment */
export const segmentSelectionCopy = {
  heading: 'Hur kan vi hjälpa er med hållbara lösningar för återvinning?',
  description: 'Ange det alternativ som passar bäst in på er verksamhet.',
} as const;

/** Steg 3 – rubrik som är gemensam; brödtext styrs per segment nedan */
export const materialStepCopy = {
  heading: 'Vilka material behöver ni hjälp att återvinna?',
} as const;

export interface SegmentTexts {
  workplace: {
    heading: string;
    description: string;
    /** Kontorsåtervinning */
    officeSizeSliderLabel?: string;
    employeesSliderLabel?: string;
    /** Detaljhandel / Hotell & restaurang */
    companyNameLabel?: string;
    /** Bostadsfastighet */
    apartmentsLabel?: string;
    coLocatedBusinessesLabel?: string;
    /** Annat */
    otherBusinessLabel?: string;
    otherBusinessPlaceholder?: string;
  };
  material: {
    /** Tom sträng = ingen extra beskrivning under rubriken (t.ex. bostäder) */
    sectionDescription: string;
  };
}

export const segmentTexts = {
  Kontorsåtervinning: {
    workplace: {
      heading: 'Hur stor är er arbetsplats?',
      description: 'Ange nedan uppgifter för snabbare och mer precis handläggning.',
      officeSizeSliderLabel: 'Ungefär hur stort är ert kontor?',
      employeesSliderLabel: 'Hur många personer jobbar på din arbetsplats?',
    },
    material: {
      sectionDescription:
        'Nedan finner ni några vanligt förekommande material. Vi rekommenderar att ni sorterar minst fem fraktioner!',
    },
  },
  Bostadsfastighet: {
    workplace: {
      heading: 'Information om er bostadsfastighet',
      description: 'Ange nedan uppgifter för snabbare och mer precis handläggning.',
      apartmentsLabel: 'Antalet lägenheter',
      coLocatedBusinessesLabel: 'Antal samlokaliserade verksamheter',
    },
    material: {
      sectionDescription:
        'Material (Fastighetsnära insamling av förpackningsavfall innebär att ni behöver minst minst sju avfallstyper, se förvalda material nedan). Utöver kan ni komplettera utifrån era behov.',
    },
  },
  Detaljhandel: {
    workplace: {
      heading: 'Vad heter er affärsverksamhet?',
      description: 'Ange nedan uppgifter för snabbare och mer precis handläggning.',
      companyNameLabel: 'Butiken, kedjans eller varumärkets namn',
    },
    material: {
      sectionDescription:
        'Nedan finner ni några vanligt förekommande material. Vi rekommenderar att ni sorterar minst fem fraktioner!',
    },
  },
  'Hotell & restaurang': {
    workplace: {
      heading: 'Vad heter er affärsverksamhet?',
      description: 'Ange nedan uppgifter för snabbare och mer precis handläggning.',
      companyNameLabel: 'Vad heter ert hotell eller restaurang (varumärke)?',
    },
    material: {
      sectionDescription:
        'Nedan finner ni några vanligt förekommande material. Vi rekommenderar att ni sorterar minst fem fraktioner!',
    },
  },
  Annat: {
    workplace: {
      heading: 'Beskriv er verksamhet',
      description: 'Ange nedan uppgifter för snabbare och mer precis handläggning.',
      otherBusinessLabel: 'Beskriv er verksamhet?',
      otherBusinessPlaceholder: 'Beskrivning',
    },
    material: {
      sectionDescription:
        'Nedan finner ni några vanligt förekommande material. Vi rekommenderar att ni sorterar minst fem fraktioner!',
    },
  },
} satisfies Record<SegmentTitle, SegmentTexts>;

export function getSegmentTexts(segment: string): SegmentTexts | undefined {
  if (!segment || !(segment in segmentTexts)) {
    return undefined;
  }
  return segmentTexts[segment as SegmentTitle];
}
